import React, {useEffect, useRef, useState} from 'react'
import {createPortal} from "react-dom";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";

const TAB_KENNWORT = "KENNWORT";
const TAB_BENUTZERNAME = "BENUTZERNAME";

// Ablauf Kennwort vergessen
const PHASE_ANFORDERN = 1;
const PHASE_CODE = 2;
const PHASE_NEUES_KENNWORT = 3;
const PHASE_FERTIG = 4;

/**
 * Zugang vergessen im neuen Design, im Stil des LoginDialog. Ersetzt in den neuen Ansichten den ZugangVergessenDialog
 * (Drawer); die Aufrufe an den Server sind dieselben.
 */
export default function ZugangVergessenDialog({onClose}) {

    const [tab, setTab] = useState(TAB_KENNWORT);
    const [phase, setPhase] = useState(PHASE_ANFORDERN);
    const [username, setUsername] = useState("");
    const [code, setCode] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [kennwortSichtbar, setKennwortSichtbar] = useState(false);
    const [email, setEmail] = useState("");
    const [benutzernameAngefordert, setBenutzernameAngefordert] = useState(false);
    const [laeuft, setLaeuft] = useState(false);
    const [fehler, setFehler] = useState(undefined);
    const erstesFeldRef = useRef(null);

    useEffect(() => {
        // nach jedem Schritt bzw. Tabwechsel in das erste Feld springen
        if (erstesFeldRef.current) {
            erstesFeldRef.current.focus();
        }
    }, [tab, phase]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    const wechsleTab = (neuerTab) => {
        setFehler(undefined);
        setTab(neuerTab);
    }

    const sende = (url, data, onErfolg) => {
        setFehler(undefined);
        setLaeuft(true);
        FetchUtil.fetchPost(url,
            data,
            antwort => {
                setLaeuft(false);
                onErfolg(antwort);
            },
            responseNotOk => {
                setLaeuft(false);
                setFehler("Fehler: " + responseNotOk.message);
            },
            error => {
                setLaeuft(false);
                setFehler("Fehler: " + error.message);
            }
        );
    }

    const userUrl = () => ConfigUtil.getConfig().resourceUrls.user;

    const codeAnfordern = (event) => {
        event.preventDefault();
        if (username.trim() === "" || laeuft) {
            return;
        }
        sende(userUrl() + "/kennwortvergessencodeanfordern?param=" + encodeURIComponent(username), {}, () => setPhase(PHASE_CODE));
    }

    const codePruefen = (event) => {
        event.preventDefault();
        if (code.trim() === "" || laeuft) {
            return;
        }
        sende(userUrl() + "/kennwortvergessencodeueberpruefen?code=" + encodeURIComponent(code), {}, () => setPhase(PHASE_NEUES_KENNWORT));
    }

    const kennwortSpeichern = (event) => {
        event.preventDefault();
        if (password1 === "" || password2 === "" || laeuft) {
            return;
        }
        sende(userUrl() + "/kennwortvergessenchangepassword?code=" + encodeURIComponent(code), {password1: password1, password2: password2},
            () => setPhase(PHASE_FERTIG));
    }

    const benutzernameAnfordern = (event) => {
        event.preventDefault();
        if (email.trim() === "" || laeuft) {
            return;
        }
        sende(userUrl() + "/usernamevergessen", {email: email}, (message) => {
            if (message !== null && message !== undefined && message !== "") {
                setFehler(message);
            } else {
                setBenutzernameAngefordert(true);
            }
        });
    }

    const getFehler = () => fehler && <p className="dhpt-login-fehler" role="alert"><i className="pi pi-exclamation-triangle" aria-hidden="true"/>{fehler}</p>;

    const getAbsendeKnopf = (label, aktiv) => <button type="submit" className="dhpt-knopf-primaer" disabled={!aktiv || laeuft}>
        {laeuft ? <><i className="pi pi-spin pi-spinner" aria-hidden="true"/>{label} …</> : label}
    </button>;

    const getKennwortFeld = (label, wert, setWert, ref) => <label className="dhpt-feld">
        <span className="dhpt-feld-label">{label}</span>
        <span className="dhpt-feld-mit-knopf">
            <input ref={ref} type={kennwortSichtbar ? "text" : "password"} className="dhpt-feld-eingabe" autoComplete="new-password"
                   value={wert} onChange={(event) => setWert(event.target.value)}/>
            <button type="button" className="dhpt-feld-knopf" aria-label={kennwortSichtbar ? "Kennwort verbergen" : "Kennwort anzeigen"}
                    aria-pressed={kennwortSichtbar} onClick={() => setKennwortSichtbar(!kennwortSichtbar)}>
                <i className={kennwortSichtbar ? "pi pi-eye-slash" : "pi pi-eye"} aria-hidden="true"/>
            </button>
        </span>
    </label>;

    const getErfolg = (icon, text) => <div className="dhpt-dialog-erfolg" role="status">
        <i className={icon} aria-hidden="true"/>
        <p>{text}</p>
        <button type="button" className="dhpt-knopf-primaer" onClick={() => onClose()}>Zurück zum Login</button>
    </div>;

    const getKennwortBereich = () => {
        if (phase === PHASE_CODE) {
            return <form className="dhpt-login-form" onSubmit={codePruefen} noValidate>
                <p className="dhpt-hinweis dhpt-dialog-text">
                    Aus Sicherheitsgründen müssen wir deine Identität überprüfen. Sofern wir zu deinen Daten ein Konto gefunden haben,
                    haben wir dir einen Code an deine E-Mail-Adresse geschickt. Gib diesen bitte hier ein.
                </p>
                <label className="dhpt-feld">
                    <span className="dhpt-feld-label">Code</span>
                    <input ref={erstesFeldRef} type="text" className="dhpt-feld-eingabe" autoComplete="one-time-code" autoCapitalize="none" spellCheck={false}
                           value={code} onChange={(event) => setCode(event.target.value)}/>
                </label>
                {getFehler()}
                {getAbsendeKnopf("Weiter", code.trim() !== "")}
                <p className="dhpt-hinweis dhpt-dialog-text">
                    Keine Mail erhalten? Prüfe bitte auch deinen SPAM-Ordner, ansonsten nimm Kontakt mit unserem Support auf.
                </p>
            </form>;
        }
        if (phase === PHASE_NEUES_KENNWORT) {
            return <form className="dhpt-login-form" onSubmit={kennwortSpeichern} noValidate>
                <p className="dhpt-hinweis dhpt-dialog-text">Vergib jetzt dein neues Kennwort.</p>
                {getKennwortFeld("Neues Kennwort", password1, setPassword1, erstesFeldRef)}
                {getKennwortFeld("Kennwort wiederholen", password2, setPassword2, undefined)}
                {getFehler()}
                {getAbsendeKnopf("Kennwort speichern", password1 !== "" && password2 !== "")}
            </form>;
        }
        if (phase === PHASE_FERTIG) {
            return getErfolg("pi pi-check-circle",
                "Dein Kennwort wurde geändert, du kannst dich nun mit deinem Benutzernamen und deinem Kennwort anmelden. Sofern du weiter Probleme hast, nimm Kontakt mit unserem Support auf.");
        }
        return <form className="dhpt-login-form" onSubmit={codeAnfordern} noValidate>
            <p className="dhpt-hinweis dhpt-dialog-text">Gib deinen Benutzernamen oder deine E-Mail-Adresse ein, wir senden dir einen Code zu.</p>
            <label className="dhpt-feld">
                <span className="dhpt-feld-label">Benutzername oder E-Mail-Adresse</span>
                <input ref={erstesFeldRef} type="text" className="dhpt-feld-eingabe" autoComplete="username" autoCapitalize="none" spellCheck={false}
                       value={username} onChange={(event) => setUsername(event.target.value)}/>
            </label>
            {getFehler()}
            {getAbsendeKnopf("Weiter", username.trim() !== "")}
        </form>;
    }

    const getBenutzernameBereich = () => {
        if (benutzernameAngefordert) {
            return getErfolg("pi pi-envelope", "Dein Benutzername wurde angefordert. Bitte prüfe deine Mails (auch SPAM).");
        }
        return <form className="dhpt-login-form" onSubmit={benutzernameAnfordern} noValidate>
            <p className="dhpt-hinweis dhpt-dialog-text">Gib deine E-Mail-Adresse ein, wir senden dir deinen Benutzernamen zu.</p>
            <label className="dhpt-feld">
                <span className="dhpt-feld-label">E-Mail-Adresse</span>
                <input ref={erstesFeldRef} type="email" className="dhpt-feld-eingabe" autoComplete="email" autoCapitalize="none" spellCheck={false}
                       value={email} onChange={(event) => setEmail(event.target.value)}/>
            </label>
            {getFehler()}
            {getAbsendeKnopf("Anfordern", email.trim() !== "")}
        </form>;
    }

    const getTab = (id, label, icon) => <button type="button" role="tab" aria-selected={tab === id}
                                                className={"dhpt-dialog-tab" + (tab === id ? " dhpt-dialog-tab-aktiv" : "")}
                                                onClick={() => wechsleTab(id)}>
        <i className={icon} aria-hidden="true"/>{label}
    </button>;

    const dialog = <div className="dhpt-modal-hintergrund" onMouseDown={(event) => {
        // Klick neben den Dialog schließt ihn
        if (event.target === event.currentTarget) {
            onClose();
        }
    }}>
        <div className="dhpt-modal dhpt-zugang" role="dialog" aria-modal="true" aria-labelledby="dhpt-zugang-titel">
            <div className="dhpt-modal-kopf">
                <h2 id="dhpt-zugang-titel" className="dhpt-modal-titel"><i className="pi pi-key" aria-hidden="true"/>Zugang vergessen</h2>
                <button type="button" className="dhpt-modal-schliessen" aria-label="Schließen" onClick={() => onClose()}>
                    <i className="pi pi-times" aria-hidden="true"/>
                </button>
            </div>
            <div className="dhpt-dialog-tabs" role="tablist">
                {getTab(TAB_KENNWORT, "Kennwort", "pi pi-lock")}
                {getTab(TAB_BENUTZERNAME, "Benutzername", "pi pi-user")}
            </div>
            <div role="tabpanel">
                {tab === TAB_KENNWORT ? getKennwortBereich() : getBenutzernameBereich()}
            </div>
        </div>
    </div>;

    // direkt in die Seite hängen (Farbvariablen aus .dhpt-seite), unabhängig vom Ort des Aufrufs
    const ziel = document.querySelector(".dhpt-seite");
    return ziel ? createPortal(dialog, ziel) : dialog;
}
